const DashboardCurrency = {
  /**
   * Converts from minor units (cents) to major units (dollars)
   * @param minorUnits - The value in minor units (e.g., 2500 cents)
   * @returns The value in major units (e.g., 25.00 dollars)
   * @example fromMinorUnit(2500) // returns 25.00
   */
  fromMinorUnit: (minorUnits: number): number => {
    return minorUnits / 100;
  },

  /**
   * Converts from major units (dollars) to minor units (cents)
   * @param majorUnits - The value in major units (e.g., 25.50 dollars)
   * @returns The value in minor units (e.g., 2550 cents)
   * @example toMinorUnit(25.50) // returns 2550
   */
  toMinorUnit: (majorUnits: number): number => {
    return Math.round(majorUnits * 100);
  },

  /**
   * Formats a price value as currency (for values already in major units/dollars)
   * @param price - The price value (in major units/dollars) to format
   * @param currencyCode - The currency code (default: 'USD')
   * @returns Formatted currency string
   */
  displayValue: (
    price: string | number,
    currencyCode = 'USD'
  ): string => {
    const priceAsNumber = typeof price === 'string' ? parseFloat(price) : price;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currencyCode,
      minimumFractionDigits: 2,
    }).format(priceAsNumber);
  }
};

export { DashboardCurrency };
